import { render, staticRenderFns } from "./LanguageSelect.vue?vue&type=template&id=577e527d"
import script from "./LanguageSelect.vue?vue&type=script&lang=js"
export * from "./LanguageSelect.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelect.vue?vue&type=style&index=0&id=577e527d&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports